import React, { Component } from 'react'
import '../styles/ThemesCart.css'
import LAIcon from '../images/Themes/icon-small-la.png'
import VBNIcon from '../images/Themes/icon-small-vbn.png'
import AbattoirIcon from '../images/Themes/icon-small-abattoir.png'
import YakuzaIcon from '../images/Themes/icon-small-yakuza.png'
import TombeauIcon from '../images/Themes/icon-small-tombeau.png'
import EditIcon from '../images/Booking/pen.png'
import DeleteIcon from '../images/Booking/cross.png'
import MarkerIcon from '../images/Booking/marker.png'
import CalendarIcon from '../images/Booking/calendar-blue.png'
import PlayerIcon from '../images/Booking/player-icon.png'
import GlobeIcon from '../images/Booking/globe.png'
import CupCake from '../images/Booking/cupcake.png'
import { API_ROOT } from '../api-config'
import { Cookies } from 'react-cookie-banner'
import { injectIntl, defineMessages } from "react-intl"
import axios from 'axios'

const themeIconConverter = (code) => {
  switch (code) {
    case '27':
      return LAIcon
    case '28':
      return VBNIcon
    case '29':
      return AbattoirIcon
    case '31':
      return YakuzaIcon
    case '32':
      return TombeauIcon
    default:
      break
  }
}

const formatDateWithZero = (date) => {
  const formattedDate = date.split("-")
  let y, M, d

  y = formattedDate[0]
  M = formattedDate[1].length < 2 ? `0${formattedDate[1]}` : formattedDate[1]
  d = formattedDate[2].length < 2 ? `0${formattedDate[2]}` : formattedDate[2]

  return `${d}/${M}/${y}`
}

const buildFormBody = (body) => {
  let formBody = []

  for (let property in body) {
    const encodedKey = encodeURIComponent(property);
    const encodedValue = encodeURIComponent(body[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }

  formBody = formBody.join("&")

  return formBody
}

const buildAPI_URL_Booking = (idReservation, tokenReservation) => {
  return `${API_ROOT}FrontGetReservationDetails.php?id_reservation=${idReservation}&token_reservation=${tokenReservation}`
}

class ThemesCart extends Component {
  constructor(props) {
    super(props)

    this.state = {
      hasOption: false,
      totalPrice: 0
    }
  }

  formatLanguage = (lang) => {
    switch (lang) {
      case 'french':
        return 'Fr'
      case 'english':
        return 'En'
      default:
        break
    }
  }

  formatDate = (date, slot) => {
    if (slot) {
      const slotHour = slot.split(":")[0]
      const slotMinutes = slot.split(":")[1]
      if (this.props.lang === "fr") {
        return `${formatDateWithZero(date)}, à ${slotHour}h${slotMinutes}`
      } else {
        return `${formatDateWithZero(date)}, ${slotHour}h${slotMinutes}`
      }
    }
  }

  getStreetAddress = (room) => {
    switch (room) {
      case '27':
        return "24 rue Emile Lepeu 75011 PARIS"
      case '28':
        return "24 rue Emile Lepeu 75011 PARIS"
      case '29':
        return "23 rue Servan 75011 PARIS"
      case '31':
        return "23 rue Servan 75011 PARIS"
      case '32':
        return "23 rue Servan 75011 PARIS"
      default:
        break
    }
  }

  toggleOption = async (optionId, resaId, resaToken, hasOption) => {
    let body = {
      id_reservation: resaId,
      token_reservation: this.findToken(resaId),
      id_room_option: optionId
    }

    const url = hasOption ? `${API_ROOT}FrontDeleteOptionFromReservation.php` : `${API_ROOT}FrontAddOptionToReservation.php`

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
      method: 'post',
      body: buildFormBody(body)
    })
    .then(response => response.json())
    .then(data => {
      this.props.updateBookings(data)
      const totalPrice = data.rooms.filter(x => x.id === resaId).shift().price_reservation_total_without_promo
      this.setState({ hasOption: !this.state.hasOption, totalPrice: totalPrice })
    })
    .catch(error => console.log(error))
  }

  setTotalPrice = (slot) => {
    let totalPrice
    if ( slot.room_option_name) {
      totalPrice = slot.price_reservation_total
    } else {
      totalPrice = slot.price_reservation_total_without_promo
    }
    this.setState({ totalPrice: totalPrice })
  }

  getBookingInfo = async (idOrder, tokenOrder) => {
    return await axios.get(buildAPI_URL_Booking(idOrder, tokenOrder))
      .then(response => {
        const booking = response.data
        this.setState({
          totalPrice: booking.order_item_price,
          hasOption: !booking.room_option_name === null
        })
      })
      .catch(error => console.log(error))
  }

  findToken = (id) => {
    const cookies = new Cookies()
    return cookies.get("bookingsTokens").filter(x => x.id_room_reservation == id).shift().id_room_reservation_token
  }

  componentDidMount() {
    this.setTotalPrice(this.props.slot)

    if (this.props.slot.room_option_name) {
      this.setState({ hasOption: true })
    }
  }

  render() {
    const slot = this.props.slot
    const {intl:{formatMessage}} = this.props
    const themeCodeConverter = (code) => {
      switch (code) {
        case '27':
          return formatMessage(messages.la)
        case '28':
          return formatMessage(messages.VBN)
        case '29':
          return formatMessage(messages.slaughterhouse)
        case '31':
          return formatMessage(messages.yakuza)
        case '32':
          return formatMessage(messages.tombeau)
        default:
          break
      }
    }
    return (
      <div
        className={slot.room_id === "28" ? "themes-cart themes-cart--vbn" : "themes-cart"}>
        <div className="themes-cart-header">
          <div className="themes-cart-header-title">
            <img src={themeIconConverter(slot.room_id)} className="themes-cart-icon" alt=""/>
            <div className="themes-cart-title">{themeCodeConverter(slot.room_id)}</div>
          </div>
          <div className="themes-cart-action-container">
            <div
              onClick={() => this.props.editCartItem(slot)}
              className="themes-cart-action themes-cart-edit">
              <img src={EditIcon} alt="edit" />
              <span>{formatMessage(messages.edit)}</span>
            </div>
            <div
              onClick={() => this.props.deleteCartItem(slot)}
              className="themes-cart-action themes-cart-delete">
              <img src={DeleteIcon} alt="delete" />
              <span>{formatMessage(messages.delete)}</span>
            </div>
          </div>
        </div>
        <div className="themes-cart-content">
          <ul className="themes-cart-info">
            <li>
              <img src={MarkerIcon} alt="marker"/>
              <span className="themes-cart-info-title">{formatMessage(messages.place)} </span>
              <span>{this.getStreetAddress(slot.room_id)}</span>
            </li>
            <li>
              <img src={CalendarIcon} alt="calendar"/>
              <span className="themes-cart-info-title">{formatMessage(messages.date)} </span>
              <span>{this.formatDate(slot.reservation_date, slot.time_begin)}</span>
            </li>
            <div className="themes-cart-info-row">
              <li>
                <img src={PlayerIcon} alt="players"/>
                <span className="themes-cart-info-title">{formatMessage(messages.players)} </span>
                <span>{slot.quantity_player}</span>
              </li>
              <li>
                <img src={GlobeIcon} alt="language"/>
                <span className="themes-cart-info-title">{formatMessage(messages.language)} </span>
                <span>{slot.lang}</span>
              </li>
            </div>
            <li className="themes-cart-price">{Math.floor(this.state.totalPrice)},<sup>{((Math.round(this.state.totalPrice % 1) * 100) / 100).toFixed(2).split(".")[1]}</sup>€</li>
          </ul>
          {
            slot.room_id === "28"
              ?
               <div className={this.state.hasOption ? "themes-cart-option themes-cart-option--active" : "themes-cart-option"}>
                 <div className="themes-cart-option-content">
                   <img src={CupCake} alt="cupcake" className="themes-cart-option-icon" />
                   <div className="themes-cart-option-text">
                     <div className="themes-cart-option-text-container">
                       <h4>{formatMessage(messages.customizationTitle)}</h4>
                       <div className="themes-cart-option-price">{this.props.VBNOptionPrice},<sup>00</sup>€</div>
                     </div>
                     <p>{formatMessage(messages.customizationNote)}</p>
                     <p>
                       <span className="customization-learn-more customization-learn-more--booking" onClick={() => this.props.togglePopInVBNCustom()}>{formatMessage(messages.customizationLearnMore)} <span className="question-mark">?</span></span>
                       <span className="themes-cart-option-more-info">
                       </span>
                     </p>
                   </div>
                 </div>
                 <div onClick={() => this.toggleOption(3, slot.id, slot.id_room_reservation_token, this.state.hasOption)} className="themes-cart-option-cta">
                   {
                    !this.state.hasOption
                    ? formatMessage(messages.addCustomization)
                    : formatMessage(messages.deleteCustomization)
                   }
                 </div>
               </div>
              : null
          }

        </div>
      </div>
    )
  }
}

const messages = defineMessages({
  la: {
    id: 'themes.la',
    defaultMessage: 'Lost Asylum'
  },
  VBN: {
    id: 'themes.VBN',
    defaultMessage: 'Very Bad Night'
  },
  slaughterhouse: {
    id: 'themes.slaughterhouse',
    defaultMessage: "L'abattoir"
  },
  yakuza: {
    id: 'themes.yakuza',
    defaultMessage: "Mission Yakuza"
  },
  tombeau: {
    id: 'themes.tombeau',
    defaultMessage: "L'Expédition Maudite"
  },
  place: {
    id: 'themesCart.place',
    defaultMessage: "Lieu :"
  },
  date: {
    id: 'themesCart.date',
    defaultMessage: "Date :"
  },
  players: {
    id: 'themesCart.players',
    defaultMessage: "Joueurs :"
  },
  language: {
    id: 'themesCart.language',
    defaultMessage: "Langue :"
  },
  edit: {
    id: 'themesCart.edit',
    defaultMessage: "Modifier"
  },
  delete: {
    id: 'themesCart.delete',
    defaultMessage: "Effacer"
  },
  customizationTitle: {
    id: 'themesCart.customizationTitle',
    defaultMessage: "Option de personnalisation"
  },
  customizationNote: {
    id: 'themesCart.customizationNote',
    defaultMessage: "Disponible uniquement 3 jours avant la réservation"
  },
  customizationLearnMore: {
    id: 'themesCart.customizationLearnMore',
    defaultMessage: "En savoir plus"
  },
  addCustomization: {
    id: 'themesCart.addCustomization',
    defaultMessage: "Ajouter cette option"
  },
  deleteCustomization: {
    id: 'themesCart.deleteCustomization',
    defaultMessage: "Supprimer cette option"
  },
})

export default injectIntl(ThemesCart)



// WEBPACK FOOTER //
// ./src/components/ThemesCart.js